<div class="column-tabs" *ngIf="columnTabsMenu">
    <div class="column-tabs__list">
        <a href="javascript:void(0)" class="column-tabs__link" (click)="setColumnWidth(1)"
            [ngClass]="{'active': tab==='tab1'}">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="20" height="20" fill="white" stroke="#767676" />
            </svg>
        </a>
        <a href="javascript:void(0)" class="column-tabs__link column-tabs__link--two-column-link"
            (click)="setColumnWidth(2)" [ngClass]="{'active': tab==='tab2'}">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="8" height="20" fill="white" stroke="#767676" />
                <rect x="12.5" y="0.5" width="8" height="20" fill="white" stroke="#767676" />
            </svg>

        </a>
        <a href="javascript:void(0)" class="column-tabs__link column-tabs__link--three-column-link"
            (click)="setColumnWidth(3)" [ngClass]="{'active': tab==='tab3'}">
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="5" height="20" fill="white" stroke="#767676" />
                <rect x="8.5" y="0.5" width="5" height="20" fill="white" stroke="#767676" />
                <rect x="16.5" y="0.5" width="5" height="20" fill="white" stroke="#767676" />
            </svg>
        </a>
    </div>
</div>

<div class="edit-save-box" [ngClass]="CloseSidebar ? 'hide-sidebar' : 'show-sidebar'"
    *ngIf="(!NoreportsAvailable && isAllowed) && !MinimizeMaximize">
    <a class="sidebar-arrow edit" href="javascript:void(0)" ptoolTip="Edit preference settings"
        (click)="editSettingClickEvent()">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.38462 3.76923C3.14932 3.76923 3.76923 3.14932 3.76923 2.38462C3.76923 1.61991 3.14932 1 2.38462 1C1.61991 1 1 1.61991 1 2.38462C1 3.14932 1.61991 3.76923 2.38462 3.76923Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M3.76953 2.38477H13.0003" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
            <path
                d="M6.99985 8.38446C7.76455 8.38446 8.38446 7.76455 8.38446 6.99985C8.38446 6.23515 7.76455 5.61523 6.99985 5.61523C6.23515 5.61523 5.61523 6.23515 5.61523 6.99985C5.61523 7.76455 6.23515 8.38446 6.99985 8.38446Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M1 7H5.61538M8.38462 7H13" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
            <path
                d="M11.6151 13.0002C12.3798 13.0002 12.9997 12.3803 12.9997 11.6156C12.9997 10.8509 12.3798 10.231 11.6151 10.231C10.8504 10.231 10.2305 10.8509 10.2305 11.6156C10.2305 12.3803 10.8504 13.0002 11.6151 13.0002Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M10.2308 11.6152H1" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>
    </a>    
    <a class="sidebar-arrow save" href="javascript:void(0)" ptoolTip="Save preference settings"
     (click)="saveSettingClickEvent()">
        <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M18.1716 1C18.702 1 19.2107 1.21071 19.5858 1.58579L22.4142 4.41421C22.7893 4.78929 23 5.29799 23 5.82843V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H18.1716ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21L5 21L5 15C5 13.3431 6.34315 12 8 12L16 12C17.6569 12 19 13.3431 19 15V21H20C20.5523 21 21 20.5523 21 20V6.82843C21 6.29799 20.7893 5.78929 20.4142 5.41421L18.5858 3.58579C18.2107 3.21071 17.702 3 17.1716 3H17V5C17 6.65685 15.6569 8 14 8H10C8.34315 8 7 6.65685 7 5V3H4ZM17 21V15C17 14.4477 16.5523 14 16 14L8 14C7.44772 14 7 14.4477 7 15L7 21L17 21ZM9 3H15V5C15 5.55228 14.5523 6 14 6H10C9.44772 6 9 5.55228 9 5V3Z"
                fill="#0F0F0F" />
        </svg>
    </a>    
</div>

<div class="kpi-report-layout" [ngClass]="MinimizeMaximize ? 'maximize-window1' : ''">
    <div class="kpi-report-layout__left" [ngClass]="editScreen ? 'show-drag-icon' : ''">
        <div class="kpi-report-layout__block-box" [ngClass]="!NoreportsAvailable ? '' : 'noreports-spacing'">
            <!-- No reports available -->
            <div class="no-reports-available-block" *ngIf="NoreportsAvailable && !formBlock">
                <p *ngIf="isAllowed">
                    <small>No reports available at the moment.</small>
                    Start creating reports from the right panel.
                </p>
                <p *ngIf="!isAllowed">
                    You do not have a permission to create new report.
                </p>
            </div>

            <!-- Reports available -->
            <div class="column-block {{columnClass}}"
                [ngClass]="!NoreportsAvailable || formBlock ? 'show-reports-column-outer' : 'hide-reports-column-outer'"
                #dropListContainer cdkDropListGroup>
                <!-- [style.width.%]="columnWidth" -->
                <div [ngClass]="item.isMaxMinimizeReport ? 'maximize-box' : ''"
                    *ngFor="let item of kpiReportModel; let i = index" cdkDropList [cdkDropListData]="i">
                    <div class="xyz-report-block" cdkDrag [cdkDragData]="item.reportSortOrder"
                        (cdkDragEntered)="dragEntered($event)" (cdkDragMoved)="dragMoved($event)"
                        (cdkDragDropped)="dragDropped($event)">
                        <div class="xyz-report-block__header">
                            <div class="xyz-report-block__header-left">
                                <span cdkDragHandle>
                                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.6 13C1.16 13 0.783201 12.8407 0.469601 12.5222C0.156001 12.2037 -0.000531975 11.8213 1.35823e-06 11.375C1.35823e-06 10.9281 0.156801 10.5454 0.470401 10.2269C0.784001 9.90844 1.16053 9.74946 1.6 9.75C2.04 9.75 2.4168 9.90925 2.7304 10.2277C3.044 10.5462 3.20053 10.9287 3.2 11.375C3.2 11.8219 3.0432 12.2046 2.7296 12.5231C2.416 12.8416 2.03947 13.0005 1.6 13ZM6.4 13C5.96 13 5.5832 12.8407 5.2696 12.5222C4.956 12.2037 4.79947 11.8213 4.8 11.375C4.8 10.9281 4.9568 10.5454 5.2704 10.2269C5.584 9.90844 5.96053 9.74946 6.4 9.75C6.84 9.75 7.2168 9.90925 7.5304 10.2277C7.844 10.5462 8.00053 10.9287 8 11.375C8 11.8219 7.8432 12.2046 7.5296 12.5231C7.216 12.8416 6.83947 13.0005 6.4 13ZM1.6 8.125C1.16 8.125 0.783201 7.96575 0.469601 7.64725C0.156001 7.32875 -0.000531975 6.94633 1.35823e-06 6.5C1.35823e-06 6.05312 0.156801 5.67044 0.470401 5.35194C0.784001 5.03344 1.16053 4.87446 1.6 4.875C2.04 4.875 2.4168 5.03425 2.7304 5.35275C3.044 5.67125 3.20053 6.05367 3.2 6.5C3.2 6.94687 3.0432 7.32956 2.7296 7.64806C2.416 7.96656 2.03947 8.12554 1.6 8.125ZM6.4 8.125C5.96 8.125 5.5832 7.96575 5.2696 7.64725C4.956 7.32875 4.79947 6.94633 4.8 6.5C4.8 6.05312 4.9568 5.67044 5.2704 5.35194C5.584 5.03344 5.96053 4.87446 6.4 4.875C6.84 4.875 7.2168 5.03425 7.5304 5.35275C7.844 5.67125 8.00053 6.05367 8 6.5C8 6.94687 7.8432 7.32956 7.5296 7.64806C7.216 7.96656 6.83947 8.12554 6.4 8.125ZM1.6 3.25C1.16 3.25 0.783201 3.09075 0.469601 2.77225C0.156001 2.45375 -0.000531975 2.07133 1.35823e-06 1.625C1.35823e-06 1.17813 0.156801 0.795439 0.470401 0.476939C0.784001 0.158439 1.16053 -0.000540287 1.6 1.37946e-06C2.04 1.37946e-06 2.4168 0.159251 2.7304 0.477751C3.044 0.796251 3.20053 1.17867 3.2 1.625C3.2 2.07188 3.0432 2.45456 2.7296 2.77306C2.416 3.09156 2.03947 3.25054 1.6 3.25ZM6.4 3.25C5.96 3.25 5.5832 3.09075 5.2696 2.77225C4.956 2.45375 4.79947 2.07133 4.8 1.625C4.8 1.17813 4.9568 0.795439 5.2704 0.476939C5.584 0.158439 5.96053 -0.000540287 6.4 1.37946e-06C6.84 1.37946e-06 7.2168 0.159251 7.5304 0.477751C7.844 0.796251 8.00053 1.17867 8 1.625C8 2.07188 7.8432 2.45456 7.5296 2.77306C7.216 3.09156 6.83947 3.25054 6.4 3.25Z"
                                            fill="#707070" />
                                    </svg>
                                </span>
                                <h3>{{item.reportName}}</h3>

                                <div class="rename-report form__group"
                                    [ngClass]="item.isRenameClicked ? 'show-renameinput' : 'hide-renameinput'">
                                    <input type="text" class="form__control" [(ngModel)]="reportName" required />                                    
                                    <div class="save-cancel">
                                        <a class="add-a-new-report" href="javascript:void(0)"
                                            (click)="CancelledRenameReport();">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13 13L1 1M13 1L1 13" stroke="#6F64A7" stroke-width="1.6"
                                                    stroke-linecap="round" />
                                            </svg>
                                        </a>
                                        <a class="add-a-new-report" href="javascript:void(0)"
                                            (click)="SaveRenameReport();">
                                            <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M15.3125 1.23375L4.8125 11.7337L0 6.92125L1.23375 5.6875L4.8125 9.2575L14.0788 0L15.3125 1.23375Z"
                                                    fill="#6F64A7" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="xyz-report-block__header-right" #targetEl>
                                <a href="javascript:void(0)" class="zoome-icon"
                                    pTooltip="{{item.isMaxMinimizeReport?'Minimize':'Maximize'}}" tooltipPosition="left"
                                    [ngClass]="MinimizeMaximize ? 'maximize-icon' : ''"
                                    (click)="MaximizeWindow(item); onReportSelection(item); quickMenu.hide();">
                                    <svg class="zoome-icon__zoome" width="15" height="15" viewBox="0 0 15 15"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.66083 8.16083C5.8108 8.01138 6.01203 7.92461 6.22365 7.91814C6.43528 7.91168 6.64143 7.98601 6.80023 8.12604C6.95904 8.26607 7.05859 8.46129 7.07867 8.67206C7.09874 8.88283 7.03784 9.09334 6.90833 9.26083L6.83917 9.33917L2.845 13.3333H5C5.2124 13.3336 5.41669 13.4149 5.57114 13.5607C5.72559 13.7065 5.81853 13.9058 5.83098 14.1178C5.84342 14.3299 5.77444 14.5386 5.63811 14.7015C5.50179 14.8644 5.30841 14.9691 5.0975 14.9942L5 15H0.833333C0.629222 15 0.432219 14.925 0.27969 14.7894C0.127161 14.6538 0.0297143 14.4669 0.00583331 14.2642L0 14.1667V10C0.00023559 9.7876 0.0815659 9.58331 0.227374 9.42886C0.373181 9.27441 0.572461 9.18147 0.784496 9.16902C0.99653 9.15658 1.20532 9.22556 1.36819 9.36189C1.53107 9.49821 1.63575 9.69159 1.66083 9.9025L1.66667 10V12.155L5.66083 8.16083ZM14.1667 0C14.3708 2.69255e-05 14.5678 0.0749635 14.7203 0.210596C14.8728 0.346229 14.9703 0.533124 14.9942 0.735833L15 0.833333V5C14.9998 5.2124 14.9184 5.41669 14.7726 5.57114C14.6268 5.72559 14.4275 5.81853 14.2155 5.83098C14.0035 5.84342 13.7947 5.77444 13.6318 5.63811C13.4689 5.50179 13.3643 5.30841 13.3392 5.0975L13.3333 5V2.845L9.33917 6.83917C9.1892 6.98862 8.98797 7.07539 8.77635 7.08186C8.56472 7.08832 8.35857 7.01399 8.19977 6.87396C8.04096 6.73393 7.94141 6.53871 7.92133 6.32794C7.90126 6.11717 7.96216 5.90666 8.09167 5.73917L8.16083 5.66083L12.155 1.66667H10C9.7876 1.66643 9.58331 1.5851 9.42886 1.43929C9.27441 1.29349 9.18147 1.09421 9.16902 0.882171C9.15658 0.670136 9.22556 0.46135 9.36189 0.298473C9.49821 0.135595 9.69159 0.0309197 9.9025 0.00583331L10 0H14.1667Z"
                                            fill="#919191" />
                                    </svg>

                                    <svg class="zoome-icon__minimize" width="16" height="15" viewBox="0 0 16 15"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.42169 14.7569C1.27172 14.9064 1.07049 14.9931 0.858867 14.9996C0.647242 15.0061 0.441092 14.9317 0.282288 14.7917C0.123483 14.6517 0.023932 14.4565 0.00385386 14.2457C-0.0162243 14.0349 0.0446764 13.8244 0.174186 13.6569L0.243353 13.5786L4.23752 9.58442L2.08252 9.58442C1.87012 9.58419 1.66583 9.50286 1.51138 9.35705C1.35693 9.21124 1.26399 9.01196 1.25154 8.79993C1.2391 8.58789 1.30808 8.37911 1.44441 8.21623C1.58073 8.05335 1.77411 7.94867 1.98502 7.92359L2.08252 7.91775L6.24919 7.91775C6.4533 7.91778 6.6503 7.99272 6.80283 8.12835C6.95536 8.26398 7.05281 8.45088 7.07669 8.65359L7.08252 8.75109L7.08252 12.9178C7.08228 13.1302 7.00095 13.3344 6.85515 13.4889C6.70934 13.6433 6.51006 13.7363 6.29802 13.7487C6.08599 13.7612 5.8772 13.6922 5.71433 13.5559C5.55145 13.4195 5.44677 13.2262 5.42169 13.0153L5.41585 12.9178L5.41585 10.7628L1.42169 14.7569Z"
                                            fill="#919191" />
                                        <path
                                            d="M8.27979 6.87143C8.43232 7.00707 8.62932 7.082 8.83343 7.08203L13.0001 7.08203L13.0976 7.0762C13.3085 7.05111 13.5019 6.94644 13.6382 6.78356C13.7745 6.62068 13.8435 6.41189 13.8311 6.19986C13.8186 5.98783 13.7257 5.78855 13.5712 5.64274C13.4168 5.49693 13.2125 5.4156 13.0001 5.41536L10.8451 5.41536L14.8393 1.4212L14.9084 1.34286C15.0379 1.17537 15.0988 0.964862 15.0788 0.754093C15.0587 0.543324 14.9591 0.3481 14.8003 0.208072C14.6415 0.0680437 14.4354 -0.00628763 14.2238 0.000174447C14.0121 0.00663653 13.8109 0.0934085 13.6609 0.242865L9.66676 4.23703L9.66676 2.08203L9.66093 1.98453C9.63584 1.77362 9.53117 1.58024 9.36829 1.44392C9.20541 1.30759 8.99663 1.23861 8.78459 1.25105C8.57256 1.2635 8.37328 1.35644 8.22747 1.51089C8.08166 1.66534 8.00033 1.86963 8.0001 2.08203L8.0001 6.2487L8.00593 6.3462C8.02981 6.54891 8.12726 6.7358 8.27979 6.87143Z"
                                            fill="#919191" />
                                    </svg>

                                </a>
                                <a href="javascript:void(0)" class="refresh-btn" pTooltip="Refresh"
                                    tooltipPosition="left"
                                    (click)="onReportSelection(item);onRefreshReport(true, item.kpiUserReportPrefrenceId); quickMenu.hide();">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14"
                                            stroke="#919191" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </a>
                                <a href="javascript:void(0)" class="dot-action" pTooltip="Actions"
                                    tooltipPosition="left"
                                    (click)="quickMenu.toggle($event, targetEl); onReportSelection(item);menuClicked(item)">
                                    <svg width="24" height="7" viewBox="0 0 24 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="3" cy="3.5" r="3" fill="#919191" />
                                        <circle cx="12" cy="3.5" r="3" fill="#919191" />
                                        <circle cx="21" cy="3.5" r="3" fill="#919191" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <div class="xyz-report-block__filter">
                            <div class="xyz-report-block__filter-left">
                                <a href="javascript:void(0)" class="filter-action"
                                    (click)="Filters.toggle($event); onReportSelection(item); getSelectionCount('filter');">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.3223 16.5H6.39474V8.42307V8.24224L6.27906 8.10324L0.5 1.15891V0.959989L0.910407 1.45316L6.51754 8.19109V15.8667V16.3667H7.01754H7.06572H7.27419L7.42092 16.2186L9.61836 14.0005L9.76316 13.8544V13.6486V8.19202L15.1115 1.4439L15.5 0.953724V1.15798L9.99411 8.10486L9.88597 8.24131V8.41543V13.9123L7.3223 16.5ZM1.29474 0.633333H0.5V0.5H15.5V0.633333H14.7196H1.29474Z"
                                            fill="#666666" stroke="#5C5C5C" />
                                    </svg>
                                    Filters
                                </a>
                            </div>

                            <div class="xyz-report-block__filter-right">
                                <div class="select-chart">
                                    <p-select *ngIf="item.orgReportName == 'combined'"
                                        class="form__dropdown select-box" [(ngModel)]="item.combinedReportAverageBy"
                                        [options]="CombinedReportAverageByDropdown" averageDropdown placeholder="Avg"
                                        optionLabel="name" optionValue="value" filter="true"
                                        (onChange)="onReportSelection(item); onAverageChange(item.kpiUserReportPrefrenceId)" appendTo="body">
                                    </p-select>
                                    <a href="javascript:void(0)" class="chart-action" *ngIf="item.orgReportName == 'column' && !item.isDataTableView"
                                        (click)="ColumnChart.toggle($event); onReportSelection(item); getSelectionCount('columnChart');">
                                        <svg class="chart-action__chart-icon" fill="#000000" width="20px" height="20px"
                                            viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M228,204H216V40a4.0002,4.0002,0,0,0-4-4H156a4.0002,4.0002,0,0,0-4,4V84H100a4.0002,4.0002,0,0,0-4,4v44H44a4.0002,4.0002,0,0,0-4,4v68H28a4,4,0,0,0,0,8H228a4,4,0,0,0,0-8ZM104,92h48V204H104ZM48,140H96v64H48Zm112,64V44h48V204Z" />
                                        </svg>
                                        <!-- Column Chart -->
                                        {{getSelectedChartType(item.columnType)}}

                                        <svg class="chart-action__chart-arrow" width="12" height="8" viewBox="0 0 12 8"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1.71429 0.5L6 4.875L10.2857 0.5L12 1.375L6 7.5L0 1.375L1.71429 0.5Z"
                                                fill="#575757" />
                                        </svg>
                                    </a>

                                    <a href="javascript:void(0)" class="chart-action"
                                        (click)="YAxisCategory.toggle($event); onReportSelection(item); getSelectionCount('visualization');">
                                        <svg class="chart-action__chart-icon" version="1.1" id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490"
                                            xml:space="preserve">
                                            <g>
                                                <g>
                                                    <g id="XMLID_38_">
                                                        <g>
                                                            <rect x="200" y="10" style="fill:#99A0A4;" width="90"
                                                                height="35" />
                                                            <polygon style="fill:#99A0A4;"
                                                                points="480,335 480,370 10,370 10,335 25,335 465,335 				" />
                                                            <polygon style="fill:#FFFFFF;"
                                                                points="465,45 465,335 25,335 25,45 200,45 290,45 				" />
                                                        </g>
                                                        <path style="fill:#231F20;" d="M480,325h-5V45c0-5.523-4.477-10-10-10H300V10c0-5.523-4.477-10-10-10h-90
                                                            c-5.523,0-10,4.477-10,10v25H25c-5.523,0-10,4.477-10,10v280h-5c-5.523,0-10,4.477-10,10v35c0,5.523,4.477,10,10,10h152.338
                                                            l-50.913,84.855l17.149,10.29L185.662,380H235v110h20V380h49.338l57.087,95.145l17.149-10.29L327.662,380H480
                                                            c5.523,0,10-4.477,10-10v-35C490,329.477,485.523,325,480,325z M210,20h70v15h-70V20z M35,55h420v270H35V55z M470,360H20v-15h450
                                                            V360z" />
                                                    </g>
                                                </g>
                                                <g id="XMLID_37_">
                                                    <g>
                                                        <rect x="300" y="90" style="fill:#231F20;" width="50"
                                                            height="35" />
                                                        <rect x="220" y="150" style="fill:#231F20;" width="50"
                                                            height="35" />
                                                        <rect x="300" y="125" style="fill:#231F20;" width="50"
                                                            height="165" />
                                                        <rect x="220" y="185" style="fill:#231F20;" width="50"
                                                            height="105" />
                                                        <rect x="140" y="245" style="fill:#231F20;" width="50"
                                                            height="45" />
                                                        <rect x="140" y="210" style="fill:#231F20;" width="50"
                                                            height="35" />
                                                    </g>
                                                    <g>
                                                        <path style="fill:#231F20;"
                                                            d="M190,200h-50c-5.523,0-10,4.477-10,10v80c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-80
                                                            C200,204.477,195.523,200,190,200z M180,220v15h-30v-15H180z M150,280v-25h30v25H150z" />
                                                        <path style="fill:#231F20;"
                                                            d="M270,140h-50c-5.523,0-10,4.477-10,10v140c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10V150
                                                            C280,144.477,275.523,140,270,140z M260,160v15h-30v-15H260z M230,280v-85h30v85H230z" />
                                                        <path style="fill:#231F20;"
                                                            d="M350,80h-50c-5.523,0-10,4.477-10,10v200c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10V90
                                                            C360,84.477,355.523,80,350,80z M340,100v15h-30v-15H340z M310,280V135h30v145H310z" />
                                                    </g>
                                                </g>
                                                <g>
                                                    <rect x="65" y="80" style="fill:#231F20;" width="55" height="20" />
                                                </g>
                                                <g>
                                                    <rect x="65" y="110" style="fill:#231F20;" width="110"
                                                        height="20" />
                                                </g>
                                                <g>
                                                    <rect x="65" y="140" style="fill:#231F20;" width="80" height="20" />
                                                </g>
                                                <g>
                                                    <rect x="155" y="80" style="fill:#231F20;" width="20" height="20" />
                                                </g>
                                            </g>
                                        </svg>
                                        Parameters
                                        <svg class="chart-action__chart-arrow" width="12" height="8" viewBox="0 0 12 8"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1.71429 0.5L6 4.875L10.2857 0.5L12 1.375L6 7.5L0 1.375L1.71429 0.5Z"
                                                fill="#575757" />
                                        </svg>
                                    </a>
                                    <!-- <a href="javascript:void(0)" class="chart-action"
                                        (click)="TimePeriod.toggle($event); onReportSelection(item); getSelectionCount('timeperiod');">
                                        Time Period
                                        <svg  class="chart-action__chart-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.71429 0.5L6 4.875L10.2857 0.5L12 1.375L6 7.5L0 1.375L1.71429 0.5Z"
                                                fill="#575757" />
                                        </svg>
                                    </a> -->
                                </div>

                                <!-- <a href="javascript:void(0)" class="appointment-action"
                                    (click)="YAxisCategory.toggle($event); onReportSelection(item); getSelectionCount('YAxisCategory');">
                                    Select Category
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.71429 0.5L6 4.875L10.2857 0.5L12 1.375L6 7.5L0 1.375L1.71429 0.5Z"
                                            fill="#575757" />
                                    </svg>
                                </a> -->

                            </div>
                        </div>

                        <div class="xyz-report-block__chart">
                            <!-- <img class="img" src="/assets/img/trending-analysis-img.jpg" alt="trending analysis"> -->
                            <div class="xyz-report-block__highcharts-outer"
                                id="{{'mchart-line'+item.kpiUserReportPrefrenceId}}" *ngIf="!item.isDataTableView">
                            </div>
                            <span class="chart-notes" *ngIf="item.orgReportName == 'combined'">Days with zero data are not considered for representation</span>
                            <div class="highcharts-table"
                                *ngIf="item.isDataTableView && item.orgReportName != 'combined'">
                                <!-- <p-table #table 
                                    class="table-outer appt-not-scheduled" sortMode="single" [sortOrder]="1"
                                    sortField="year" [paginator]="totalRecords>0?true:false"
                                    [rows]="getTotalRows()" [totalRecords]="totalRecords" [lazy]="true" [customSort]="true"
                                    [first]="item.kpiReportSearchRequestModel?.FirstRecordIndex" [value]="item.kpiReportDataTable"
                                    (onLazyLoad)="onLazyLoad($event)" [scrollable]="true" scrollHeight="calc(100vh - 297px)"
                                    dataKey="crmSalesOrderAPPId" scrollDirection="both"> -->
                                <p-table class="table-outer" [value]="item.kpiReportDataTable" [responsive]="true"
                                    [paginator]="item.totalRecords>0?true:false" sortMode="single" sortField="year"
                                    [first]="item.kpiReportSearchRequestModel?.FirstRecordIndex" [sortOrder]="1"
                                    [rows]="getTotalRows(item.kpiUserReportPrefrenceId)"
                                    [totalRecords]="item.totalRecords" [lazy]="true" [customSort]="true"
                                    (onLazyLoad)="onLazyLoad($event,item.kpiUserReportPrefrenceId)"
                                    responsiveLayout="scroll">
                                    <ng-template pTemplate="header" let-columns>
                                        <tr *ngIf="item.totalRecords > 0">
                                            <th class="table-outer__th table-outer__soid">S.O. ID</th>
                                            <th class="table-outer__th table-outer__year"
                                                *ngIf="item.orgReportName != 'combined'">Year</th>
                                            <th class="table-outer__th table-outer__date"
                                                *ngIf="item.orgReportName == 'combined'">Date</th>
                                            <th class="table-outer__th table-outer__month"
                                                *ngIf="item.orgReportName != 'combined'">Month</th>
                                            <th class="table-outer__th" *ngIf="item.orgReportName == 'combined'">3 Days
                                                Moving Average</th>
                                            <th class="table-outer__th">Status</th>
                                            <th class="table-outer__th">Classification</th>
                                            <th class="table-outer__th">Branch</th>
                                            <th class="table-outer__th">Facility</th>
                                            <th class="table-outer__th">Therapist</th>
                                            <th class="table-outer__th">BookedBy</th>
                                            <th class="table-outer__th">Insurance</th>
                                            <th class="table-outer__th">Appointment Type</th>
                                        </tr>
                                    </ng-template>

                                    <ng-template pTemplate="body" let-kpi let-columns="columns">
                                        <tr>
                                            <td class="table-outer__td table-outer__soid">{{kpi.crmSalesOrderAPPId}}
                                            </td>
                                            <td class="table-outer__td table-outer__year"
                                                *ngIf="item.orgReportName != 'combined'">{{kpi.year}}</td>
                                            <td class="table-outer__td table-outer__date"
                                                *ngIf="item.orgReportName == 'combined'">{{kpi.appDate |
                                                date:appDateFormat.dateFormat}}</td>
                                            <td class="table-outer__td table-outer__month"
                                                *ngIf="item.orgReportName != 'combined'">{{kpi.month}}</td>
                                            <td class="table-outer__td" *ngIf="item.orgReportName == 'combined'">
                                                {{kpi.movingAverage}}</td>
                                            <td class="table-outer__td">{{kpi.status}}</td>
                                            <td class="table-outer__td">{{kpi.crmClassification}}</td>
                                            <td class="table-outer__td">{{kpi.crmBranch}}</td>
                                            <td class="table-outer__td">{{kpi.crmFacilityName}}</td>
                                            <td class="table-outer__td">{{kpi.appTherapistName}}</td>
                                            <td class="table-outer__td">{{kpi.schAppointmentBookedByPerson}}</td>
                                            <td class="table-outer__td">{{kpi.insurance}}</td>
                                            <td class="table-outer__td">{{kpi.schAppointmentType}}</td>
                                        </tr>
                                    </ng-template>

                                    <ng-template pTemplate="paginatorleft" class="table-pagination">
                                        <span class="table-pagination__records">
                                            Total Records : &nbsp;<strong> {{item.totalRecords}}</strong>
                                        </span>
                                    </ng-template>

                                    <!-- <ng-template pTemplate="paginator" class="table-pagination">
                                        <p-paginator [rows]="getTotalRows()" [totalRecords]="item.totalRecords"></p-paginator>
                                    </ng-template> -->
                                    <!-- <ng-template pTemplate="paginatorright" class="table-pagination">
                                        <span class="table-pagination__select">
                                            <p-select class="select-box" panelStyleClass="paginetion-selectbox" appendTo="body"
                                                [(ngModel)]="item.selectedpage" id="item.kpiUserReportPrefrenceId" placeholder="Select Page"
                                                [showClear]="true"
                                                (onChange)="onPageChange($event)"></p-select>
                                        </span>
                                    </ng-template> -->

                                </p-table>

                                <div class="no-records-found-appointment" *ngIf="!loading && item.totalRecords <= 0"
                                    [attr.colspan]="13">
                                    No records found
                                </div>

                                <!-- <table class="custom-table highcharts-table__table">
                                    <thead>
                                        <tr>
                                            <th>S.O. ID</th>
                                            <th *ngIf="item.orgReportName != 'combined'">Year</th>
                                            <th *ngIf="item.orgReportName == 'combined'">Date</th>
                                            <th *ngIf="item.orgReportName != 'combined'">Month</th>
                                            <th *ngIf="item.orgReportName == 'combined'">3 Days Moving Average</th>
                                            <th>Status</th>
                                            <th>Classification</th>
                                            <th>Branch</th>
                                            <th>Facility</th>
                                            <th>Therapist</th>
                                            <th>BookedBy</th>
                                            <th>Insurance</th>
                                            <th>Appointment Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let kpi of item.kpiReportDataTable">
                                            <td>{{kpi.crmSalesOrderAPPId}}</td>
                                            <td *ngIf="item.orgReportName != 'combined'">{{kpi.year}}</td>
                                            <td *ngIf="item.orgReportName == 'combined'">{{kpi.appDate |
                                                date:appDateFormat.dateFormat}}</td>
                                            <td *ngIf="item.orgReportName != 'combined'">{{kpi.month}}</td>
                                            <td *ngIf="item.orgReportName == 'combined'">{{kpi.movingAverage}}</td>
                                            <td>{{kpi.status}}</td>
                                            <td>{{kpi.crmClassification}}</td>
                                            <td>{{kpi.crmBranch}}</td>
                                            <td>{{kpi.crmFacilityName}}</td>
                                            <td>{{kpi.appTherapistName}}</td>
                                            <td>{{kpi.schAppointmentBookedByPerson}}</td>
                                            <td>{{kpi.insurance}}</td>
                                            <td>{{kpi.schAppointmentType}}</td>
                                        </tr>
                                    </tbody>

                                </table> -->
                            </div>

                            <div class="highcharts-table"
                                *ngIf="item.isDataTableView && item.orgReportName == 'combined'">
                                <p-table class="table-outer" [value]="item.kpiMovingReportDataTable" [responsive]="true"
                                    [paginator]="item.totalRecords>0?true:false" sortMode="single" sortField="year"
                                    [first]="item.kpiReportSearchRequestModel?.FirstRecordIndex" [sortOrder]="1"
                                    [rows]="getTotalRows(item.kpiUserReportPrefrenceId)"
                                    [totalRecords]="item.totalRecords" [lazy]="true" [customSort]="true"
                                    (onLazyLoad)="onLazyLoad($event,item.kpiUserReportPrefrenceId)"
                                    responsiveLayout="scroll">
                                    <ng-template pTemplate="header" let-columns>
                                        <tr *ngIf="item.totalRecords > 0">
                                            <th class="table-outer__th table-outer__date">Date</th>
                                            <th class="table-outer__th table-outer__year">Moving Average</th>
                                            <th class="table-outer__th table-outer__year">Count</th>
                                            <th class="table-outer__th">Status</th>
                                        </tr>
                                    </ng-template>

                                    <ng-template pTemplate="body" let-kpi let-columns="columns">
                                        <tr>
                                            <td class="table-outer__td table-outer__date">{{kpi.appDate |
                                                date:appDateFormat.dateFormat}}</td>
                                            <td class="table-outer__td table-outer__year">{{formatNumber(kpi.moving)}}
                                            </td>
                                            <td class="table-outer__td table-outer__year">{{kpi.count}}</td>
                                            <td class="table-outer__td">{{kpi.status}}</td>
                                        </tr>
                                    </ng-template>

                                    <ng-template pTemplate="paginatorleft" class="table-pagination">
                                        <span class="table-pagination__records">
                                            Total Records : &nbsp;<strong> {{item.totalRecords}}</strong>
                                        </span>
                                    </ng-template>
                                </p-table>

                                <div class="no-records-found-appointment" *ngIf="!loading && item.totalRecords <= 0"
                                    [attr.colspan]="13">
                                    No records found
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="loader-block1" *ngIf="item.isLoading">
                        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff"
                            animationDuration=".8s">
                        </p-progressSpinner>
                    </div>
                </div>
                <!-- Add New report form-->
                <!-- *ngIf="formBlock"  [style.width.%]="columnWidth"-->
                <div class="drag-form" id="ScrollTop1">
                    <form class="form" [formGroup]="form" [ngClass]="AddNewReport ? 'showform' : 'hideform'">
                        <div class="form__heading">
                            <h3>Add {{selectedKPIReportTypeToCreate?.kpiReportName}} Report</h3>

                            <a href="javascript:void(0)" class="close-icon" (click)="clickEventcloseForm();">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 14L2 2M14 2L2 14" stroke="#454545" stroke-width="2.2"
                                        stroke-linecap="round" />
                                </svg>
                            </a>
                        </div>
                        <div class="form__group">
                            <label class="form__label">Report Name</label>
                            <input type="text" formControlName="reportName" class="form__control" pInputText maxlength="50">
                            <span class="invalid-feedback"
                                *ngIf="isSubmitReport && (hasError(formFields.reportName, 'required') || hasError(formFields.reportName, 'whitespace'))">{{validationMessages.reportNameValidation.required}}</span>
                                <span class="invalid-feedback" *ngIf="isSubmitReport && hasInvalidChar">Report name contains invalid character.</span>
                        </div>

                        <div class="form__group">
                            <label class="form__label">Time Period</label>
                            <p-multiSelect class="form__multiSelect select-box" formControlName="timePeriod"
                                placeholder="Select" [options]="TimePeriodDropdown" appendTo="body"
                                optionLabel="name"></p-multiSelect>
                            <span class="invalid-feedback" *ngIf="isSubmitReport && hastimePeriodError">Time Period is
                                required</span>
                        </div>
                        <div class="form__group" *ngIf="selectedKPIReportTypeToCreate?.orgReportName == 'column'">
                            <label class="form__label">Chart View</label>
                            <p-select class="form__dropdown select-box" [options]="ComparativeChartTypeDropdown" placeholder="Select"
                                optionLabel="name" optionValue="value" filter="true" appendTo="body"
                                formControlName="chartType"></p-select>
                            <span class="invalid-feedback" *ngIf="isSubmitReport && hasChartTypeError">Chart Type is
                                required</span>
                        </div>
                        <div class="form__group" *ngIf="selectedKPIReportTypeToCreate?.orgReportName == 'combined'">
                            <label class="form__label">Average By</label>
                            <p-select class="form__dropdown select-box" [options]="CombinedReportAverageByDropdown"
                                placeholder="Select" optionLabel="name" optionValue="value" filter="true"
                                appendTo="body" formControlName="averageBy"></p-select>
                            <span class="invalid-feedback" *ngIf="isSubmitReport && hasAverageByChartTypeError">Average
                                By required</span>
                        </div>
                        <div class="form__group">
                            <label class="form__label">Parameter</label>
                            <a href="javascript:void(0)" class="visualization-fields"
                                (click)="YAxisCategory.toggle($event)">
                                <span class="visualization-fields__text">{{SelectedVisualizationFieldTexts}}</span>
                                <span class="visualization-fields__arrow">
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="chart-action__chart-arrow">
                                        <path _ngcontent-gna-c224=""
                                            d="M1.71429 0.5L6 4.875L10.2857 0.5L12 1.375L6 7.5L0 1.375L1.71429 0.5Z"
                                            fill="#575757"></path>
                                    </svg>
                                </span>
                                <span class="invalid-feedback" *ngIf="isSubmitReport && hasParameterError">Parameter is
                                    required</span>
                                    <span class="invalid-feedback" *ngIf="isSubmitReport && hasMinParameterError">Please select min 2 Parameters.</span>
                            </a>
                        </div>

                        <div class="form__group">
                            <button type="submit" class="btn btn--primary" (click)="createNewReport()">Save</button>
                        </div>
                    </form>

                    <div class="add-new-reports" [ngClass]="AddNewReport ? 'hide-new-report' : 'show-new-report'"
                        *ngIf="isAllowed">
                        <div class="add-new-reports__addnew">
                            <svg width="39" height="38" viewBox="0 0 39 38" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M38.5 19C38.5 24.0391 36.4982 28.8718 32.935 32.435C29.3718 35.9982 24.5391 38 19.5 38C14.4609 38 9.62816 35.9982 6.06497 32.435C2.50178 28.8718 0.5 24.0391 0.5 19C0.5 13.9609 2.50178 9.12816 6.06497 5.56497C9.62816 2.00178 14.4609 0 19.5 0C24.5391 0 29.3718 2.00178 32.935 5.56497C36.4982 9.12816 38.5 13.9609 38.5 19ZM20.6875 10.6875C20.6875 10.3726 20.5624 10.0705 20.3397 9.84781C20.117 9.62511 19.8149 9.5 19.5 9.5C19.1851 9.5 18.883 9.62511 18.6603 9.84781C18.4376 10.0705 18.3125 10.3726 18.3125 10.6875V17.8125H11.1875C10.8726 17.8125 10.5705 17.9376 10.3478 18.1603C10.1251 18.383 10 18.6851 10 19C10 19.3149 10.1251 19.617 10.3478 19.8397C10.5705 20.0624 10.8726 20.1875 11.1875 20.1875H18.3125V27.3125C18.3125 27.6274 18.4376 27.9295 18.6603 28.1522C18.883 28.3749 19.1851 28.5 19.5 28.5C19.8149 28.5 20.117 28.3749 20.3397 28.1522C20.5624 27.9295 20.6875 27.6274 20.6875 27.3125V20.1875H27.8125C28.1274 20.1875 28.4295 20.0624 28.6522 19.8397C28.8749 19.617 29 19.3149 29 19C29 18.6851 28.8749 18.383 28.6522 18.1603C28.4295 17.9376 28.1274 17.8125 27.8125 17.8125H20.6875V10.6875Z"
                                    fill="#6F64A7" />
                            </svg>
                            <p><a class="add-a-new-report" href="javascript:void(0)"
                                    (click)="quickAddNewReports.toggle($event)">Add a new report</a></p>
                        </div>
                    </div>


                    <div class="add-new-reports" [ngClass]="AddNewReport ? 'hide-new-report' : 'show-new-report'"
                        *ngIf="!isAllowed">
                        <div class="add-new-reports__addnew">
                            <p>You do not a have permission to create new report.</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- Sidebar -->
    <div class="kpi-report-layout__sidebar" *ngIf="isAllowed"
        [ngClass]="CloseSidebar || NoreportsAvailable ? 'show-sidebar' : 'hide-sidebar'">
        <div class="create-report-block">
            <div class="create-report-block__heading">
                <h2>Create Report</h2>
                <a href="javascript:void(0)" class="close-icon" (click)="sidebarCloseEvent()"
                    *ngIf="!NoreportsAvailable">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 14L2 2M14 2L2 14" stroke="#454545" stroke-width="2.2" stroke-linecap="round" />
                    </svg>
                </a>
            </div>
            <div class="create-report-block__scroll">
                <div class="trending-analysis-report-block" *ngFor="let kpiReport of kpiReportMasterDetails">
                    <figure class="trending-analysis-report-block__img" tooltipPosition="left"
                        pTooltip="{{kpiReport.kpiReportDescription}}">
                        <span *ngIf="kpiReport.kpiReportType=='Trending'"><img class="img"
                                src="/assets/img/trending-analysis-img.jpg" alt="trending analysis"></span>
                        <span *ngIf="kpiReport.kpiReportType=='Comparative'"><img class="img"
                                src="/assets/img/comparative-analysis-img.jpg" alt="trending analysis"></span>
                        <span *ngIf="kpiReport.kpiReportType=='Average'"><img class="img"
                                src="/assets/img/moving-average-img.jpg" alt="trending analysis"></span>
                    </figure>
                    <div class="trending-analysis-report-block__title">
                        <h3>{{kpiReport.kpiReportName}}</h3>
                        <a href="javascript:void(0)" class="btn btn--primary scrollDiv" rel="ScrollTop"
                            (click)="sidebarAddNewReport(kpiReport)">Add</a>
                    </div>
                </div>

                <!-- <div class="trending-analysis-report-block">
                    <figure class="trending-analysis-report-block__img" tooltipPosition="left"
                        pTooltip="Lorem ipsum dolor sit amet consectetur. Sit velit enim nunc sit integer gravida id risus non.">
                        <img class="img" src="/assets/img/comparative-analysis-img.jpg" alt="comparative analysis">
                    </figure>
                    <div class="trending-analysis-report-block__title">
                        <h3>Comparative Analysis</h3>
                        <a href="javascript:void(0)" class="btn btn--primary" (click)="sidebarAddNewReport()">Add</a>
                    </div>
                </div>

                <div class="trending-analysis-report-block">
                    <figure class="trending-analysis-report-block__img" tooltipPosition="left"
                        pTooltip="Lorem ipsum dolor sit amet consectetur. Sit velit enim nunc sit integer gravida id risus non.">
                        <img class="img" src="/assets/img/moving-average-img.jpg" alt="Moving Average">
                    </figure>
                    <div class="trending-analysis-report-block__title">
                        <h3>Moving Average</h3>
                        <a href="javascript:void(0)" class="btn btn--primary" (click)="sidebarAddNewReport()">Add</a>
                    </div>
                </div> -->
            </div>

        </div>
    </div>

</div>

<!-- Quick Menu Filters -->
<p-overlayPanel appendTo="body" #quickAddNewReports class="search-filter" [dismissable]="true">
    <div class="quick-link-menu">
        <ul>
            <li *ngFor="let kpiReport of kpiReportMasterDetails"><a href="javascript:void(0)"
                    (click)="clickEventAddNewReport(kpiReport); quickAddNewReports.hide()">{{kpiReport.kpiReportName}}</a>
            </li>
            <!-- <li><a href="javascript:void(0)" (click)="clickEventAddNewReport(); quickAddNewReports.hide()">Comparative
                    Analysis</a></li>
            <li><a href="javascript:void(0)" (click)="clickEventAddNewReport(); quickAddNewReports.hide()">Moving
                    Average</a></li> -->
        </ul>
    </div>
</p-overlayPanel>

<!-- Quick Menu Filters -->
<p-overlayPanel appendTo="body" #quickMenu class="search-filter" [dismissable]="true">
    <div class="quick-link-menu">
        <ul>
            <li><a href="javascript:void(0)" (click)="copyReport(); quickMenu.hide()" rel="ScrollTop"
                    class="scrollDiv">Copy & Add Report</a></li>
            <li><a href="javascript:void(0)" (click)="clickEventRenameReport(); quickMenu.hide()">Rename Report</a></li>
            <li><a href="javascript:void(0)" (click)="removeReport(); quickMenu.hide()">Delete Report</a></li>
            <li *ngIf="!IsDataTable"><a href="javascript:void(0)" (click)="showDataTable(); quickMenu.hide() ">Show
                    Table View</a></li>
            <li *ngIf="IsDataTable"><a href="javascript:void(0)" (click)="hideDataTable(); quickMenu.hide()">Show Graph
                    View</a></li>
            <!-- <li><a href="javascript:void(0)" (click)="ExportPDF(); quickMenu.hide()">Download .pdf</a></li> -->
            <li><a href="javascript:void(0)" (click)="ExportCSV(); quickMenu.hide()">Download .csv</a></li>
            <li><a href="javascript:void(0)" (click)="downloadPNG(); quickMenu.hide()">Download .png</a></li>
        </ul>
    </div>
</p-overlayPanel>

<!-- Filters -->
<p-overlayPanel class="search-filter" #Filters appendTo="body" [dismissable]="true" [showCloseIcon]="false">
    <div class="search-box-outer  kpi-filter-overly">
        <h2>Filters</h2>

        <div class="filters-boxs">
            <p-tabView class="filters-boxs__tabs-block tab-outer">
                <!-- Appt.Status -->
                <p-tabPanel header="appointmentStatus">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Appointment Status <span class="count-numbers"
                                *ngIf="appointmentStatusCnt>0">{{appointmentStatusCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllAppointmentStatus"
                                        (onChange)="selectAllCheckbox('appointmentstatus','appointmentstatus',$event)"
                                        label="Appointment Status" inputId="AppointmentStatus"></p-checkbox>
                                        <label class="checkbox-text" for="AppointmentStatus">Appointment Status</label>
                                    </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('appointmentstatus','appointmentstatus')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let appointmentStatus of AppointmentStatusDropdown">
                                        <span class="form__checkbox-outer">
                                            <p-checkbox [(ngModel)]="appointmentStatus.isChecked"
                                                [ngModelOptions]="{ standalone: true }" [value]="appointmentStatus.value"
                                                [binary]="true"
                                                [inputId]="'binary_appointmentStatus' + appointmentStatus.name"
                                                (onChange)="onCheckboxChanged('appointmentstatus')"></p-checkbox>

                                            <label class="checkbox-text" for="binary_appointmentStatus{{appointmentStatus.name}}">
                                                {{
                                                appointmentStatus.name
                                                }}
                                            </label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Appointment Types-->
                <p-tabPanel header="Appointment Types">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Appointment Types <span class="count-numbers"
                                *ngIf="selectedAppointmentTypeCnt>0">{{selectedAppointmentTypeCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                        <p-checkbox binary="true" [ngModel]="isAllAppointmentTypeSelect"
                                            (onChange)="selectAllCheckbox('filter','appointmenttype',$event)"
                                            label="Appointment Types" inputId="AppointmentTypes"></p-checkbox>
                                            <label class="checkbox-text" for="AppointmentTypes">Appointment Types</label>
                                    </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('filter','appointmenttype')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let appointmenttype of kpiReportFiltersResponseModel.kpiAppointmentTypes">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="appointmenttype.isChecked"
                                            [ngModelOptions]="{ standalone: true }"
                                            [value]="appointmenttype.appointmentTypeId" [binary]="true"
                                            [inputId]="'binary_appointmenttype' + appointmenttype.appointmentTypeId"
                                            (onChange)="onCheckboxChanged('appointmenttype')"></p-checkbox>

                                        <label class="checkbox-text" for="binary_appointmenttype{{appointmenttype.appointmentTypeId}}">{{
                                            appointmenttype.appointmentType }}</label>
                                           
                                    </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Branches-->
                <p-tabPanel header="Branches">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Branches <span class="count-numbers"
                                *ngIf="selectedBranchCnt>0">{{selectedBranchCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllBranchSelect"
                                        (onChange)="selectAllCheckbox('filter','branch',$event)"
                                        label="Branches" inputId="Branches"></p-checkbox>
                                        <label class="checkbox-text" for="Branches">Branches</label>
                                        </span>
                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('filter','branch')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let branch of kpiReportFiltersResponseModel.kpiBranches">
                                        <span class="form__checkbox-outer">
                                            <p-checkbox [(ngModel)]="branch.isChecked"
                                                [ngModelOptions]="{ standalone: true }" [value]="branch.crmBranchId"
                                                [binary]="true" [inputId]="'binary_branch' + branch.crmBranchId"
                                                (onChange)="onCheckboxChanged('branch')"></p-checkbox>
                                            <label class="checkbox-text" for="binary_branch{{branch.crmBranchId}}">{{ branch.crmBranchName
                                                }}</label>
                                            </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Classifications-->
                <p-tabPanel header="Classifications">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Classifications <span class="count-numbers"
                                *ngIf="selectedClassificationsCnt>0">{{selectedClassificationsCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                     <span class="form__checkbox-outer">
                                        <p-checkbox binary="true" [ngModel]="isAllClassificationsSelect"
                                            (onChange)="selectAllCheckbox('filter','classification',$event)"
                                            label="Classifications" inputId="Classifications"></p-checkbox>
                                         <label class="checkbox-text" for="Classifications">Classifications</label>
                                    </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('filter','classification')">Clear All</a>
                                </div>
                            </div>

                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let classification of kpiReportFiltersResponseModel.kpiClassifications">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="classification.isChecked"
                                            [ngModelOptions]="{ standalone: true }"
                                            [value]="classification.crmClassificationTypeId" [binary]="true"
                                            [inputId]="'binary_classification' + classification.crmClassificationTypeId"
                                            (onChange)="onCheckboxChanged('classification')"></p-checkbox>
                                        <label class="checkbox-text" for="binary_classification{{classification.crmClassificationTypeId}}">{{
                                            classification.crmClassificationDisplayName }}</label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Facilities-->
                <p-tabPanel header="Facilities">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Facilities <span class="count-numbers"
                                *ngIf="selectedFacilityCnt>0">{{selectedFacilityCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllFacilitySelect"
                                        (onChange)="selectAllCheckbox('filter','facility',$event)"
                                        label="Facilities" inputId="Facilities"></p-checkbox>
                                         <label class="checkbox-text" for="Facilities">Facilities</label>
                                    </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('filter','facility')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let facilities of kpiReportFiltersResponseModel.kpiFacilities">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="facilities.isChecked"
                                            [ngModelOptions]="{ standalone: true }" [value]="facilities.facilityId"
                                            [binary]="true" [inputId]="'binary_facility' + facilities.facilityId"
                                            (onChange)="onCheckboxChanged('facility')"></p-checkbox>

                                        <label  class="checkbox-text" for="binary_facility{{facilities.facilityId}}">{{ facilities.facilityName
                                            }}</label>
                                            </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Insurances-->
                <p-tabPanel header="Insurances">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Insurances <span class="count-numbers"
                                *ngIf="selectedInsuranceCnt>0">{{selectedInsuranceCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllInsuranceSelect"
                                        (onChange)="selectAllCheckbox('filter','insurance',$event)"
                                        label="Insurances" inputId="Insurances"></p-checkbox>
                                        <label class="checkbox-text" for="Insurances">Insurances</label>
                                    </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('filter','insurance')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let insurance of kpiReportFiltersResponseModel.kpiInsurances">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="insurance.isChecked"
                                            [ngModelOptions]="{ standalone: true }"
                                            [value]="insurance.crmInsurancePatientId" [binary]="true"
                                            [inputId]="'binary_insurance' + insurance.crmPolicyHolderName"
                                            (onChange)="onCheckboxChanged('insurance')"></p-checkbox>

                                        <label class="checkbox-text" for="binary_insurance{{insurance.crmPolicyHolderName}}">{{
                                            insurance.crmPolicyHolderName }}</label>
                                            </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Months-->
                <p-tabPanel header="Months">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Months <span class="count-numbers" *ngIf="selectedMonthsCnt>0">{{selectedMonthsCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllMonthsSelect"
                                        (onChange)="selectAllCheckbox('timeperiod','month',$event)"
                                        label="Months" inputId="Months"></p-checkbox>
                                        <label class="checkbox-text" for="Months">Months</label>
                                        </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('timeperiod','month')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let months of TimePeriodMonthDropdown">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="months.isChecked"
                                            [ngModelOptions]="{ standalone: true }" [value]="months.name"
                                            [binary]="true" [inputId]="'binary_month' + months.value"
                                            (onChange)="onCheckboxChanged('month')"></p-checkbox>

                                        <label class="checkbox-text" for="binary_month{{months.value}}">{{ months.name }}</label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Schedulers-->
                <p-tabPanel header="Schedulers">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Schedulers <span class="count-numbers"
                                *ngIf="selectedSchedulerCnt>0">{{selectedSchedulerCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllSchedulerSelect"
                                        (onChange)="selectAllCheckbox('filter','scheduler',$event)"
                                        label="Schedulers" inputId="Schedulers"></p-checkbox>
                                        <label class="checkbox-text" for="Schedulers">Schedulers</label>
                                        </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('filter','scheduler')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let scheduler of kpiReportFiltersResponseModel?.kpiSchedulers">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="scheduler.isChecked"
                                            [ngModelOptions]="{ standalone: true }" [value]="scheduler.userInfoId"
                                            [binary]="true" [inputId]="'binary_scheduler' + scheduler.userInfoId"
                                            (onChange)="onCheckboxChanged('scheduler')"></p-checkbox>
                                        <label class="checkbox-text" for="binary_scheduler{{scheduler.userInfoId}}">{{ scheduler.bookedBy
                                            }}</label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Therapists-->
                <p-tabPanel header="Therapists">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Therapists <span class="count-numbers"
                                *ngIf="selectedTherapistCnt>0">{{selectedTherapistCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllTherapistSelect"
                                        (onChange)="selectAllCheckbox('filter','therapist',$event)"
                                        label="Therapists" inputId="Therapists"></p-checkbox>

                                        <label class="checkbox-text" for="Therapists">Therapists</label>
                                    </span>
                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('filter','therapist')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let therapist of kpiReportFiltersResponseModel.kpiTherapist">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="therapist.isChecked"
                                            [ngModelOptions]="{ standalone: true }" [value]="therapist.therapistId"
                                            [binary]="true" [inputId]="'binary_therapist' + therapist.therapistId"
                                            (onChange)="onCheckboxChanged('therapist')"></p-checkbox>

                                        <label class="checkbox-text" for="binary_therapist{{therapist.therapistId}}">{{
                                            therapist.therapistName }}</label>
                                            </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Years-->
                <p-tabPanel header="Years">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Years <span class="count-numbers" *ngIf="selectedYearsCnt>0">{{selectedYearsCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllYearsSelect"
                                        (onChange)="selectAllCheckbox('timeperiod','year',$event)"
                                        label="Years" inputId="Years"></p-checkbox>
                                        <label class="checkbox-text" for="Years">Years</label>
                                    </span>

                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('timeperiod','year')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item" *ngFor="let years of TimePeriodDropdown">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="years.isChecked"
                                            [ngModelOptions]="{ standalone: true }" [value]="years.name" [binary]="true"
                                            [inputId]="'binary_year' + years.name"
                                            (onChange)="onCheckboxChanged('year')"></p-checkbox>

                                        <label class="checkbox-text" for="binary_year{{years.name}}">{{ years.name }}</label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
            </p-tabView>

            <div class="filters-boxs__bottom">
                <button class="btn btn--secondary" (click)="onFilterClose($event, Filters)">Cancel</button>
                <button class="btn btn--primary" (click)="onFilterSave($event, Filters)">Save Filters</button>
            </div>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel appendTo="body" #ColumnChart class="search-filter" [dismissable]="true" [showCloseIcon]="false">
    <div class="quick-link-menu kpi-quick-link-menu">
        <ul>
            <li *ngFor="let chartType of ComparativeChartTypeDropdown" [ngClass]="chartType.isChecked ? 'Active':''"><a
                    href="javascript:void(0)"
                    (click)="onColumnChartChanged(chartType,$event,ColumnChart)">{{chartType.name}}</a></li>
            <!-- <li><a href="javascript:void(0)">Stacked Column Chart</a></li> -->
        </ul>

    </div>
</p-overlayPanel>

<!-- YAxis Category -->
<p-overlayPanel appendTo="body" #YAxisCategory class="search-filter" [dismissable]="true" [showCloseIcon]="false">
    <div class="search-box-outer visual-box">
        <h2>Select Horizontal Parameters</h2>
        <div class="visualization-box">
            <div class="visualization-box__addbox">
                <div class="form__group">
                    <label class="form__label">Horizontal Parameter</label>
                    <p-select class="form__dropdown select-box" [(ngModel)]="selectedCategory" *ngIf="(!AddNewReport && selectedReportItem?.orgReportName != 'combined') || 
                        (AddNewReport && selectedKPIReportTypeToCreate?.orgReportName != 'combined')"
                        [options]="FilteredYAxisCategoryDropdown" statusDropdown placeholder="Select Paramters"
                        optionLabel="name" filter="true">
                    </p-select>

                    <p-select class="form__dropdown select-box" [(ngModel)]="selectedCategory" *ngIf="(!AddNewReport && selectedReportItem?.orgReportName == 'combined')  || 
                        (AddNewReport && this.selectedKPIReportTypeToCreate?.orgReportName == 'combined')"
                        [options]="FilterCombinedYAxisCategoryDropdown" statusDropdown placeholder="Select Paramters"
                        optionLabel="name" filter="true">
                    </p-select>
                </div>
                <div class="form__btn"><button class="btn btn--primary" (click)="onVisualizationAdd()">Add</button>
                </div>
            </div>

            <div class="visualization-box__filtersbox">
                <ul cdkDropList styleClass="filterDrag" [cdkDropListData]="todo"
                    *ngIf="(!AddNewReport && selectedReportItem?.orgReportName != 'combined') || (AddNewReport && selectedKPIReportTypeToCreate?.orgReportName != 'combined')"
                    class="quick-link-menu column-display-settings__list" (cdkDropListDropped)="drop($event)">
                    <li class="column-display-settings__items" cdkDrag *ngFor="let item of todo">
                        <span class="column-display-settings__icon" cdkDragHandle>
                            <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.8 15.5C1.305 15.5 0.881101 15.3162 0.528301 14.9487C0.175501 14.5812 -0.000598472 14.14 1.52801e-06 13.625C1.52801e-06 13.1094 0.176401 12.6678 0.529201 12.3003C0.882001 11.9328 1.3056 11.7494 1.8 11.75C2.295 11.75 2.7189 11.9337 3.0717 12.3012C3.4245 12.6687 3.6006 13.11 3.6 13.625C3.6 14.1406 3.4236 14.5822 3.0708 14.9497C2.718 15.3172 2.2944 15.5006 1.8 15.5ZM7.2 15.5C6.705 15.5 6.2811 15.3162 5.9283 14.9487C5.5755 14.5812 5.3994 14.14 5.4 13.625C5.4 13.1094 5.5764 12.6678 5.9292 12.3003C6.282 11.9328 6.7056 11.7494 7.2 11.75C7.695 11.75 8.1189 11.9337 8.4717 12.3012C8.8245 12.6687 9.0006 13.11 9 13.625C9 14.1406 8.8236 14.5822 8.4708 14.9497C8.118 15.3172 7.6944 15.5006 7.2 15.5ZM1.8 9.875C1.305 9.875 0.881101 9.69125 0.528301 9.32375C0.175501 8.95625 -0.000598472 8.515 1.52801e-06 8C1.52801e-06 7.48438 0.176401 7.04281 0.529201 6.67531C0.882001 6.30781 1.3056 6.12438 1.8 6.125C2.295 6.125 2.7189 6.30875 3.0717 6.67625C3.4245 7.04375 3.6006 7.485 3.6 8C3.6 8.51562 3.4236 8.95719 3.0708 9.32469C2.718 9.69219 2.2944 9.87562 1.8 9.875ZM7.2 9.875C6.705 9.875 6.2811 9.69125 5.9283 9.32375C5.5755 8.95625 5.3994 8.515 5.4 8C5.4 7.48438 5.5764 7.04281 5.9292 6.67531C6.282 6.30781 6.7056 6.12438 7.2 6.125C7.695 6.125 8.1189 6.30875 8.4717 6.67625C8.8245 7.04375 9.0006 7.485 9 8C9 8.51562 8.8236 8.95719 8.4708 9.32469C8.118 9.69219 7.6944 9.87562 7.2 9.875ZM1.8 4.25C1.305 4.25 0.881101 4.06625 0.528301 3.69875C0.175501 3.33125 -0.000598472 2.89 1.52801e-06 2.375C1.52801e-06 1.85938 0.176401 1.41781 0.529201 1.05031C0.882001 0.682814 1.3056 0.499377 1.8 0.500002C2.295 0.500002 2.7189 0.683751 3.0717 1.05125C3.4245 1.41875 3.6006 1.86 3.6 2.375C3.6 2.89063 3.4236 3.33219 3.0708 3.69969C2.718 4.06719 2.2944 4.25063 1.8 4.25ZM7.2 4.25C6.705 4.25 6.2811 4.06625 5.9283 3.69875C5.5755 3.33125 5.3994 2.89 5.4 2.375C5.4 1.85938 5.5764 1.41781 5.9292 1.05031C6.282 0.682814 6.7056 0.499377 7.2 0.500002C7.695 0.500002 8.1189 0.683751 8.4717 1.05125C8.8245 1.41875 9.0006 1.86 9 2.375C9 2.89063 8.8236 3.33219 8.4708 3.69969C8.118 4.06719 7.6944 4.25063 7.2 4.25Z"
                                    fill="#B0A3EF" />
                            </svg>
                        </span>
                        <div class="column-display-settings__text">
                            <span>{{item.name}}</span>
                            <a href="javascript:void(0)" (click)="onVisualizationRemove(item, false)">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.8755 2.17661L2.12453 13.8234" stroke="#3E3E3E" stroke-width="2" />
                                    <path d="M13.8232 13.8755L2.17637 2.12453" stroke="#3E3E3E" stroke-width="2" />
                                </svg>
                            </a>
                        </div>
                    </li>
                </ul>

                <ul styleClass="filterDrag" *ngIf="(!AddNewReport && selectedReportItem?.orgReportName == 'combined') || 
                    (AddNewReport && selectedKPIReportTypeToCreate?.orgReportName == 'combined')"
                    class="quick-link-menu column-display-settings__list">
                    <li class="column-display-settings__items" *ngFor="let item of todo">
                        <div class="column-display-settings__text">
                            <span>{{item.name}}</span>
                            <a href="javascript:void(0)" (click)="onVisualizationRemove(item, true)"
                                *ngIf="!item.isChecked">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.8755 2.17661L2.12453 13.8234" stroke="#3E3E3E" stroke-width="2" />
                                    <path d="M13.8232 13.8755L2.17637 2.12453" stroke="#3E3E3E" stroke-width="2" />
                                </svg>
                            </a>
                            <span *ngIf="item.isChecked">
                                (Primary Field)
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
       
        <div class="filters-boxs__bottom">
            <button class="btn btn--secondary" (click)="onAppointmentStatusClose($event, YAxisCategory)">Cancel</button>
            <button class="btn btn--primary" (click)="onAppointmentStatusSave($event, YAxisCategory)">Save</button>
        </div>
    </div>
</p-overlayPanel>

<!-- Time Period -->
<p-overlayPanel class="search-filter" #TimePeriod appendTo="body" [dismissable]="true" [showCloseIcon]="false">
    <div class="search-box-outer  kpi-filter-overly kpi-filter-overly-time-period">
        <h2>Time Period</h2>

        <div class="filters-boxs">
            <p-tabView class="filters-boxs__tabs-block">
                <!-- Years-->
                <p-tabPanel header="Years">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Years <span class="count-numbers" *ngIf="selectedYearsCnt>0">{{selectedYearsCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllYearsSelect"
                                        (onChange)="selectAllCheckbox('timeperiod','year',$event)" inputId="Years2"></p-checkbox>
                                        <label class="checkbox-text" for="Years2">Years</label>
                                    </span>
                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('timeperiod','year')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item" *ngFor="let years of TimePeriodDropdown">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="years.isChecked"
                                            [ngModelOptions]="{ standalone: true }" [value]="years.name" [binary]="true"
                                            [inputId]="'binary_year' + years.name"
                                            (onChange)="onCheckboxChanged('year')"></p-checkbox>

                                        <label class="checkbox-text" for="binary_year{{years.name}}">{{ years.name }}</label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Months-->
                <p-tabPanel header="Months">
                    <ng-template pTemplate="header">
                        <span class="links">
                            Months <span class="count-numbers" *ngIf="selectedMonthsCnt>0">{{selectedMonthsCnt}}</span>
                        </span>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <div class="tab-content-box">
                            <div class="tab-content-box__header">
                                <h3 class="tab-content-box__title">
                                    <span class="form__checkbox-outer">
                                    <p-checkbox binary="true" [ngModel]="isAllMonthsSelect"
                                        (onChange)="selectAllCheckbox('timeperiod','month',$event)" inputId="Months1"></p-checkbox>
                                        <label class="checkbox-text" for="Months1">Months</label>
                                    </span>
                                </h3>
                                <div class="tab-content-box__right">
                                    <a href="javascript:void(0)" class="btn btn--accent"
                                        (click)="onFilterClear('timeperiod','month')">Clear All</a>
                                </div>
                            </div>
                            <div class="scroll">
                                <ul class="selecteble-filter-right">
                                    <li class="selecteble-filter-right__item"
                                        *ngFor="let months of TimePeriodMonthDropdown">
                                        <span class="form__checkbox-outer">
                                        <p-checkbox [(ngModel)]="months.isChecked"
                                            [ngModelOptions]="{ standalone: true }" [value]="months.name"
                                            [binary]="true" [inputId]="'binary_month' + months.value"
                                            (onChange)="onCheckboxChanged('month')"></p-checkbox>

                                        <label class="checkbox-text" for="binary_month{{months.value}}">{{ months.name }}</label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-template>
                </p-tabPanel>
                <!-- Weeks-->
            </p-tabView>

            <div class="filters-boxs__bottom">
                <button class="btn btn--secondary" (click)="onTimePeriodClose($event, TimePeriod)">Cancel</button>
                <button class="btn btn--primary" (click)="onTimePeriodSave($event, TimePeriod)">Save</button>
            </div>
        </div>
    </div>
</p-overlayPanel>

<div id="exportData" #exportData style="display:none;">
    <div style="padding: 2.5rem;">
        <div>
            <table id="content" class="pdf-table" width="100%" height="100vh" style="border-spacing: 0;">
                <tr>
                    <th width="120" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        S.O. ID</th>
                    <th *ngIf="!isMovingAverage" width="140"
                        style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Year</th>
                    <th *ngIf="!isMovingAverage" width="140"
                        style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Month</th>
                    <th *ngIf="isMovingAverage" width="140"
                        style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Date</th>
                    <th *ngIf="isMovingAverage" width="140"
                        style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        3 Days Moving Average</th>
                    <th width="140" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Status</th>
                    <th width="250" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Classification</th>
                    <th width="180" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Branch</th>
                    <th width="180" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Facility</th>
                    <th width="280" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Therapist</th>
                    <th width="200" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Booked By</th>
                    <th width="240" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Insurance</th>
                    <th width="230" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Appointment Type</th>
                    <!-- <th width="120" style="text-align: left; border-bottom: 2px solid #b1a6e5; padding-bottom: 8px;">
                        Count</th> -->
                </tr>
                <tr *ngFor="let kpi of kpiReportDataTable">
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.crmSalesOrderAPPId}}</td>
                    <td *ngIf="!isMovingAverage"
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.year}}</td>
                    <td *ngIf="!isMovingAverage"
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.month}}</td>
                    <td *ngIf="isMovingAverage"
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.appDate | date:appDateFormat.dateFormat}}</td>
                    <td *ngIf="isMovingAverage"
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.movingAverage}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.status}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.crmClassification}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.crmBranch}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.crmFacilityName}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.appTherapistName}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.schAppointmentBookedByPerson}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.insurance}}</td>
                    <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.schAppointmentType}}</td>
                    <!-- <td
                        style="text-align: left; border-bottom: 1px solid #d2d2d2; padding-top: 8px; padding-bottom: 8px;">
                        {{kpi.count}}</td> -->
                </tr>
            </table>
        </div>
    </div>
</div>

<div class="loader-block" *ngIf="loading">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
    </p-progressSpinner>
</div>
